<template>
  <div>
    <ClientConclusionAnamnesisFrom
      v-if="(userCanAdd || userCanEdit) && showForm"
      :anamnesis="anamnesis"
      v-on:submit="submitForm"
      v-on:cancel="closeForm"/>

    <div class="mb-5">
      <div class="py-3 px-4 border bg-light font-weight-bold text-primary position-relative">
        Анамнез

        <div
          v-if="userCanAdd"
          class="position-absolute"
          style="right:10px;top:8px;">
          <button
            class="btn btn-primary"
            @click="showForm = true">
            Новая запись анамнеза
          </button>
        </div>
      </div>

      <ClientConclusionAnamnesisList
        v-on:select="selectAnamnesis"
        :items="data" />
    </div>
  </div>
</template>

<script>
import ClientConclusionAnamnesisList from './anamnesis/List';
import ClientConclusionAnamnesisFrom from './anamnesis/Form';
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientConclusionAnamnesis',

  props: ['anamneses', 'submitAnamnesis', 'userCanAdd', 'userCanEdit'],

  components: {ClientConclusionAnamnesisList, ClientConclusionAnamnesisFrom},

  data() {
    return {
      error: '',
      success: '',
      anamnesisId: null,
      showForm: false,
    };
  },

  computed: {
    data() {
      const data = this.anamneses.map(({date, text, note, id, createdBy}) => {
        return {date, text, note, id, createdBy};
      });

      data.sort((a, b) => b.date.getTime() - a.date.getTime());

      return data;
    },

    anamnesis() {
      return this.anamneses.find(i => i.id === this.anamnesisId);
    },
  },

  methods: {
    selectAnamnesis(id) {
      if (!this.userCanEdit) {
        return false;
      }

      this.showForm = true;
      this.anamnesisId = id;
    },

    closeForm() {
      this.showForm = false;
      this.anamnesisId = null;
    },

    formatDate(date, format) {
      return formatDate(date, format);
    },


    async submitForm(data) {
      await this.submitAnamnesis(data);

      this.closeForm();
    },
  },
};
</script>
